import { render, staticRenderFns } from "./HuaYi.vue?vue&type=template&id=5d41d8a8&scoped=true&"
import script from "./HuaYi.vue?vue&type=script&lang=js&"
export * from "./HuaYi.vue?vue&type=script&lang=js&"
import style0 from "./HuaYi.vue?vue&type=style&index=0&id=5d41d8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d41d8a8",
  null
  
)

export default component.exports